import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { SiteType } from '../../context-discovery-services/enums/site-type';
import { LaunchDarklyService } from '../../context-discovery-services/services/launch-darkly.service';
import { FeatureFlags } from '../../context-discovery-services/constants/feature-flags.const';

@Component({
  selector: 'adminapp-site-type',
  templateUrl: './site-type.component.html',
  styleUrls: ['./site-type.component.scss']
})
export class SiteTypeComponent implements OnInit {

  selectedSiteType: String;

  isGatewayConfigEnabled: boolean;

  @ViewChild('ebiSiteBtn') ebiSiteBtn: any;

  @ViewChild('niagaraSiteBtn') niagaraSiteBtn: any;

  @ViewChild('gatewaySiteBtn') gatewaySiteBtn: any;

  buttonList: Array<ElementRef> = [];

  @Output()
  selectedSiteTypeEmitter = new EventEmitter<any>();

  /**
   * @param {LaunchDarklyService} ldService
   */
  constructor(private ldService: LaunchDarklyService) {
    this.isGatewayConfigEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.GATEWAY_CONFIG);
    this.ldService.flagChange.subscribe(() => {
      this.isGatewayConfigEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.GATEWAY_CONFIG);
    });
  }

  @Input()
  set siteType(typeOfSite: string) {
    if (this.selectedSiteType !== typeOfSite) {
      this.selectedSiteType = typeOfSite;
    }
    if (this.selectedSiteType) {
      if (this.selectedSiteType.toUpperCase() === SiteType.TYPE_EBI) {
        this.displaySelectedSite(this.ebiSiteBtn.nativeElement);
      }
      if (this.selectedSiteType.toUpperCase() === SiteType.TYPE_NIAGARA) {
        this.displaySelectedSite(this.niagaraSiteBtn.nativeElement);
      }
      if (this.selectedSiteType.toUpperCase() === SiteType.TYPE_GATEWAY && this.isGatewayConfigEnabled) {
        this.displaySelectedSite(this.gatewaySiteBtn.nativeElement);
      }
    }
  }

  ngOnInit() {
    this.buttonList.push(this.ebiSiteBtn);
    this.buttonList.push(this.niagaraSiteBtn);
    this.buttonList.push(this.gatewaySiteBtn);
  }

  handleEBISiteClicked() {
    this.resetSelection(this.ebiSiteBtn);
    this.displaySelectedSite(this.ebiSiteBtn.nativeElement);
    this.selectedSiteTypeEmitter.emit({ siteType: SiteType.TYPE_EBI });
  }

  handleNiagaraSiteClicked() {
    this.resetSelection(this.niagaraSiteBtn);
    this.displaySelectedSite(this.niagaraSiteBtn.nativeElement);
    this.selectedSiteTypeEmitter.emit({ siteType: SiteType.TYPE_NIAGARA });
  }

  handleGatewaySiteClicked() {
    if (this.isGatewayConfigEnabled) {
      this.resetSelection(this.gatewaySiteBtn);
      this.displaySelectedSite(this.gatewaySiteBtn.nativeElement);
      this.selectedSiteTypeEmitter.emit({ siteType: SiteType.TYPE_GATEWAY });
    }
  }

  displaySelectedSite(element) {
    if (element.classList) {
      element.classList.add('displaySelection');
    }
  }

  resetSelection(element) {
    this.buttonList.forEach(elementInList => {
      if (elementInList !== element) {
        elementInList.nativeElement.classList.remove('displaySelection');
      }
    });
  }
}
